import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import styled from 'foundations-theming/utils';
import { getCurrencyCodeString } from 'pricing-pages-ui-components/currency/types';

// Don't use `Text` as it will take precedence over any container typography
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSpan = styled.span.withConfig({
  displayName: "PriceDisplay__StyledSpan"
})(props => {
  return {
    textDecoration: props.crossedOut ? 'line-through' : 'none',
    display: 'inline',
    flexWrap: 'wrap'
  };
});
/**
 * This component is used to display a price in a given currency.
 * It is also used in the CrossedOutPrice component to display a crossed out price.
 * This should be a bare-bones component that does not have any additional styling.
 * Any additional styling should be done in the calling component.
 */

export const PriceDisplay = ({
  price,
  currencyCode,
  round = true,
  currencyCodeUnit,
  dataDiscounted,
  dataSelenium = '',
  crossedOut = false
}) => {
  const currencyCodeStr = getCurrencyCodeString(currencyCode);
  return /*#__PURE__*/_jsx(StyledSpan, {
    "data-selenium-id": dataSelenium,
    "data-test-id": dataSelenium,
    "data-discounted": dataDiscounted,
    crossedOut: crossedOut,
    children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
      trailingZeroDisplay: "stripIfInteger",
      value: round ? Math.ceil(price) : price,
      currencyCode: currencyCodeStr,
      unit: currencyCodeUnit
    })
  });
};
export const CrossedOutPrice = props => {
  return /*#__PURE__*/_jsx(PriceDisplay, Object.assign({}, props, {
    crossedOut: true
  }));
};